import {UPDATE_FIELDS_CONTACT, GET_LOCAL_FIELDS} from './action';
const initialState = {
    org_nr: '',
    company_name:'',
    adress: '',
    phone: '',
    email: '',
    description: '',
    invoice: '',
    contact: '',
    validate: false,
};

export default function Contact(state = initialState, action) {
    switch(action.type)
    {

        case GET_LOCAL_FIELDS: 
            return Object.assign({}, state, action.data);
        
        case UPDATE_FIELDS_CONTACT:
            let setState = Object.assign({}, state, action.data);
            localStorage.setItem('contact-welandutemiljo', JSON.stringify(setState));

            return setState;
        default:
        return state
    }

}


// WEBPACK FOOTER //
// ./src/Services/Contact/reducer.js